export default __webpack_public_path__ + "static/media/soaiblue.d58a40a2.jpg";